import type { NodeTypes } from '@xyflow/react';
import { AgentNode } from './AgentNode';
import { ConditionNode } from './ConditionNode';
import { WaitNode } from './WaitNode';
import { ParallelNode } from './ParallelNode';
import { MergeNode } from './MergeNode';

/** Custom React Flow node types registered by ComposerCanvas. */
export const composerNodeTypes: NodeTypes = {
  agent: AgentNode,
  condition: ConditionNode,
  wait: WaitNode,
  parallel: ParallelNode,
  merge: MergeNode,
};

export { AgentNode, ConditionNode, WaitNode, ParallelNode, MergeNode };
